/* CsakCsajok – termékgaléria kiegészítés (2026-10-23), a cc-theme-skin tölti be termékoldalon.
   1) A téma nagyító nézetében (ecx-gallery-slides) csak nyilakkal lehetett lapozni: húzásra a téma saját
      előre/hátra gombját nyomjuk meg, így a számláló, a zoom-visszaállítás és a videók kezelése a témáé marad.
      Belenagyított képen nem lapozunk (ott a húzás a kép mozgatása).
   2) A fő képsor húzásakor a bélyegkép-sor eddig az elsőt jelölte: most követi a látható képet. */
(function () {
  if (window.__ccGallerySwipe) return;
  window.__ccGallerySwipe = true;
  var still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.23,1,.32,1)';

  // ---- 1) nagyító nézet: húzás ----
  var drag = null, eatClick = false;
  function activeImg(slides) {
    var s = slides.querySelector('.is-active-gallery-slide');
    return s && (s.querySelector('.js-zoom-item') || s.querySelector('img'));
  }
  function enter(slides, dir) {
    if (still) return;
    var s = slides.querySelector('.is-active-gallery-slide');
    if (s && s.animate) s.animate([{ opacity: 0, transform: 'translateX(' + (dir * 28) + '%) scale(.97)' }, { opacity: 1, transform: 'none' }], { duration: 320, easing: EASE });
  }
  document.addEventListener('pointerdown', function (e) {
    var slides = e.target.closest && e.target.closest('ecx-gallery-slides');
    if (!slides || drag || e.target.closest('button') || (e.pointerType === 'mouse' && e.button !== 0)) return;
    var img = activeImg(slides);
    if (img && img.hasAttribute('zoomed')) return;
    drag = { slides: slides, img: img, x: e.clientX, y: e.clientY, t: Date.now(), dx: 0, axis: '' };
  }, { passive: true });
  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var mx = e.clientX - drag.x, my = e.clientY - drag.y;
    if (!drag.axis) {
      if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
      drag.axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
    }
    if (drag.axis !== 'x') return;
    drag.dx = mx;
    var next = drag.slides.querySelector(mx < 0 ? '.js-slide-next-btn' : '.js-slide-prev-btn');
    // a sor végén súrlódással enged, nem áll meg falként
    var k = next && !next.disabled ? 0.6 : 0.2;
    if (drag.img) drag.img.style.transform = 'translateX(' + (mx * k).toFixed(1) + 'px)';
  }, { passive: true });
  function end() {
    if (!drag) return;
    var d = drag; drag = null;
    if (d.axis !== 'x') return;
    eatClick = true; setTimeout(function () { eatClick = false; }, 60);
    var from = d.img ? d.img.style.transform : '';
    if (d.img) d.img.style.transform = '';
    var v = Math.abs(d.dx) / Math.max(1, Date.now() - d.t);
    var btn = d.slides.querySelector(d.dx < 0 ? '.js-slide-next-btn' : '.js-slide-prev-btn');
    if ((Math.abs(d.dx) > 50 || v > 0.11) && btn && !btn.disabled) {
      btn.click();
    } else if (d.img && d.img.animate && !still && from) {
      d.img.animate([{ transform: from }, { transform: 'none' }], { duration: 200, easing: EASE });
    }
  }
  document.addEventListener('pointerup', end, { passive: true });
  document.addEventListener('pointercancel', end, { passive: true });
  // egérrel húzás után ne kapcsoljon be a zoom
  document.addEventListener('click', function (e) {
    if (eatClick && e.target.closest && e.target.closest('ecx-gallery-slides') && !e.target.closest('button')) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  // a nyilakra és a húzásra is a megfelelő oldalról úszik be a kép
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.js-slide-next-btn, .js-slide-prev-btn');
    if (!b || b.disabled) return;
    var slides = b.closest('ecx-gallery-slides');
    var dir = b.classList.contains('js-slide-next-btn') ? 1 : -1;
    if (slides) requestAnimationFrame(function () { enter(slides, dir); });
  });

  // ---- 2) fő képsor: a bélyegkép kövesse a látható képet ----
  function syncThumbs(root) {
    var sec = root.dataset.section;
    var car = root.querySelector('ecx-carousel') || document.querySelector('ecx-carousel[data-section-id="' + sec + '"]');
    var vert = root.querySelector('ecx-vert-carousel') || document.querySelector('ecx-vert-carousel[data-section="' + sec + '"]');
    var track = car && car.querySelector('.js-carousel-items');
    if (!track || !vert || track.dataset.ccThumbSync) return;
    track.dataset.ccThumbSync = '1';
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        if (track.scrollWidth <= track.clientWidth + 2) return;
        var items = Array.prototype.filter.call(track.querySelectorAll('.js-carousel-item'), function (x) { return x.offsetWidth > 0; });
        if (!items.length) return;
        var i = Math.max(0, Math.min(items.length - 1, Math.round(track.scrollLeft / items[0].offsetWidth)));
        var mEl = items[i].dataset.mediaId ? items[i] : items[i].querySelector('[data-media-id]');
        var id = mEl && mEl.dataset.mediaId;
        if (!id) return;
        var btn = vert.querySelector('.js-slideshow-btn-thumb[data-target="' + id + '"]');
        var thumb = btn && btn.closest('.js-product-slideshow-thumb');
        if (!thumb || thumb.classList.contains('is-active-item')) return;
        vert.querySelectorAll('.js-product-slideshow-thumb').forEach(function (t) { t.classList.remove('is-active-item'); });
        thumb.classList.add('is-active-item');
        var tc = thumb.closest('.js-carousel-items');
        if (tc && tc.scrollWidth > tc.clientWidth) tc.scrollTo({ left: thumb.offsetLeft - (tc.clientWidth - thumb.offsetWidth) / 2, behavior: still ? 'auto' : 'smooth' });
      });
    }, { passive: true });
  }
  function boot() { document.querySelectorAll('ecx-prd-slideshow').forEach(syncThumbs); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
